import 'regenerator-runtime';

import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Breadcrumbs from './plugins/Breadcrumbs';
import Role from './plugins/Role';
import Auth from './plugins/Auth';
import ToggleButton from 'vue-js-toggle-button';
import vmodal from 'vue-js-modal';
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import VueToastr from 'vue-toastr';
import VueFlatPickr from 'vue-flatpickr-component';
import VueResource from 'vue-resource';
import VShowSlide from 'v-show-slide';
import VueEvents from 'vue-events';
import FunctionalCalendar from 'vue-functional-calendar';
import ThSortable from './components/core/ThSortable.vue';
import VueSweetalert2 from 'vue-sweetalert2';
import VueMq from 'vue-mq';
import Btn from './components/core/Btn.vue';
import FormBtn from './components/core/FormBtn.vue';
import FormInput from './components/core/FormInput.vue';
import FormCheckbox from './components/core/FormCheckbox.vue';
import FormGroup from './components/core/FormGroup.vue';
import FormSelect from './components/core/FormSelect.vue';
import FormTextarea from './components/core/FormTextarea.vue';
import InlineSvg from 'vue-inline-svg';
import Utils from './plugins/Utils.js';
import VueTippy, { TippyComponent } from "vue-tippy";
import VueSocialauth from 'vue-social-auth'

import 'bootstrap/js/src/util';
import 'bootstrap/js/src/dropdown';
import 'flatpickr/dist/flatpickr.css';
import "tippy.js/themes/light.css";

import acl from './acl';
import router from './router';
import store from './store';
import App from './App.vue';

import './scss/style.scss';
import './filters';

// const moment = require('moment');
// require('moment/min/locales.min');
// moment.locale('en');

Vue.component('btn', Btn);
Vue.component('form-btn', FormBtn);
Vue.component('form-input', FormInput);
Vue.component('form-checkbox', FormCheckbox);
Vue.component('form-group', FormGroup);
Vue.component('form-select', FormSelect);
Vue.component('form-textarea', FormTextarea);
Vue.component('th-sortable', ThSortable);
Vue.component('pagination', require('laravel-vue-pagination'));

Vue.use(VueMq, {
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: Infinity,
  },
});

Vue.use(FunctionalCalendar, {
  dayNames: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
});

Vue.use(VuejsDialog);
Vue.use(vmodal, { dynamic: true });
Vue.use(ToggleButton);
Vue.use(VShowSlide);
Vue.use(VueEvents);
Vue.use(Breadcrumbs, router);
Vue.use(VueSweetalert2);

Vue.use(Vuelidate);

Vue.use(Role);
Vue.use(Auth);
Vue.use(VueResource);

Vue.use(VueToastr, {
  closeButton: true,
  debug: false,
  newestOnTop: true,
  progressBar: true,
  positionClass: 'toast-top-right',
  preventDuplicates: false,
  showDuration: '300',
  hideDuration: '500',
  timeOut: '8000',
  extendedTimeOut: '1000',
  showEasing: 'swing',
  hideEasing: 'linear',
  showMethod: 'show',
  hideMethod: 'hide',
});

Vue.use(VueFlatPickr, {
  time_24hr: true,
  enableTime: false,
  altFormat: 'd.m.Y H:i',
  dateFormat: 'Y-m-d H:i:S',
  altInput: true,
  allowInput: true,
});
Vue.component('inline-svg', InlineSvg);

Vue.use(VueTippy);
// or
Vue.use(VueTippy, {
  directive: "tippy",
  flipDuration: 0,
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: false
      }
    }
  }
});

Vue.component("tippy", TippyComponent);

Vue.use(Utils);

let allowRefresh = true;
let refreshingToken = false;
const baseUrl = process.env.VUE_APP_API_BASE_URL;
const frontendBaseUrl = window.location.origin + '/login';

Vue.use(VueSocialauth, {
  property: '$socialAuth',
  bindRequestInterceptor: () => {},
  bindResponseInterceptor: () => {},
  providers: {
    google: {
      clientId: '323334242724-1qf4m74170em30hc8gv01ja0gehv1148.apps.googleusercontent.com',
      redirectUri: frontendBaseUrl,
    },
    facebook: {
      clientId: '370242966413927',
      redirectUri: frontendBaseUrl,
      // redirectUri: 'https://localhost:8080/account/login/facebook/callback',
    }
  }
})

Vue.http.interceptors.push((request, next) => {
  if (request.files === undefined) {
    // request.body = JSON.stringify(request.body);
  }

  if (request.url[0] === '/') {
    const token = Vue.auth.getToken();
    if (token && request.url !== '/auth/login') {
      request.headers.set('Authorization', `Bearer ${token}`);
    }

    request.url = `${baseUrl}${request.url}`;
  }

  // eslint-disable-next-line consistent-return
  next(function (res) {
    if (refreshingToken) {
      setTimeout(() => {
        Vue.http(request).then((data) => {
          allowRefresh = true;
          return data;
        });
      }, 1000);
      return false;
    }
    if (res.body.error === 'token_not_provided') {
      this.$auth.setCurrentRoute(this.$route, this.$store.state.user.id);
      this.$auth.destroyToken();
      this.$store.commit('logout', this);
      this.$acl.change('public');
      this.$router.push({ name: 'login' });
      return false;
    }
    if (allowRefresh && res.body.status_code === 401 && res.body.error === 'token_expired') {
      this.$auth.setCurrentRoute(this.$route, this.$store.state.user.id);
      allowRefresh = false;
      refreshingToken = true;
      this.$auth.refreshToken((newToken) => {
        request.headers.set('Authorization', `Bearer ${newToken}`);
        refreshingToken = false;
      }, () => {
        refreshingToken = false;
        this.$auth.destroyToken();
        this.$store.commit('logout', this);
        this.$acl.change('public');
        this.$router.push({ name: 'login' });
      });
      return Vue.http(request).then((data) => {
        allowRefresh = true;
        return data;
      }).catch(() => {
        allowRefresh = true;
        this.$auth.destroyToken();
        this.$store.commit('logout', this);
        this.$acl.change('public');
        this.$router.push({ name: 'login' });
      });
    }
    if (res.body.status_code === 401) {
      allowRefresh = true;
      this.$auth.destroyToken();
      this.$store.commit('logout', this);
      this.$acl.change('public');
      this.$router.push({ name: 'login' });
    }
    if (res.body.status_code === 403) {
        this.$router.push({ name: 'home' });
    }
    if (request.noAlert === undefined && (
      (typeof res.body.error !== 'undefined' && res.body.error !== 'token_expired')
      || typeof res.body.message !== 'undefined'
    )) {
      if (res.body.status_code === 200 && res.body.message !== null) {
        this.$toastr.s(res.body.message[0]);
      } else if (res.body.status_code >= 400) {
        if (typeof res.body.message === 'object') {
          Object.keys(res.body.message).forEach((key) => {
            this.$toastr.e(res.body.message[key]);
          });
        } else {
          this.$toastr.e(res.body.message);
        }
      }
    }

    if (res.body.status_code === 422) {
      Object.keys(res.body).forEach((key) => {
        this.$toastr.e(res.body[key]);
      });
    }
  });
});

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.performance = process.env.NODE_ENV !== 'production';

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

export default new Vue({
  router,
  store,
  acl,
  render: (h) => h(App),
}).$mount('#app');
